/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class LossReportAPI extends ApiClient {
  constructor() {
    super('kanban/loss_report', { accountScoped: true, apiVersion: 'v1' });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new LossReportAPI();
